import { useQuery } from "@tanstack/react-query";
import { listDocuments } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useDocuments() {
  return useQuery({
    queryKey: queryKeys.documents.all,
    queryFn: listDocuments,
    staleTime: staleTimes.documents,
  });
}
